export var VideoPreloadEnums;
(function (VideoPreloadEnums) {
    VideoPreloadEnums["AUTO"] = "auto";
    VideoPreloadEnums["METADATA"] = "metadata";
    VideoPreloadEnums["NONE"] = "none";
})(VideoPreloadEnums || (VideoPreloadEnums = {}));
//# sourceMappingURL=VideoPlayerEnums.js.map